<template lang="pug">

    .authors.accent-font

        .authors__wrap

            .authors__title

                h3.h3
                    span.decor(aria-hidden="true") &lt;/div&gt;--&gt;
                    span.underline(v-html="realTitle")

                decoration(v-if='decoration', :count='decoration.count', :active='active', :showLiteMode='false')


            .authors__text

                dl.author-list

                    .author-list__item(v-for="(item, index) in people", :style="index === people.length - 1 ? `order: ${people.length - 2}` : index === people.length - 2 ? `order: ${people.length - 1}` : ''")

                        dt.author-list__position(v-html="item.position")

                        dd.author-list__names

                            span(v-for="name in item.names", v-html="name")

</template>

<script>
/* data info (for links) */
import data from '@/assets/data/data';

import Decoration from './illustrations/Decoration.vue';
import {wrapHTMLSymbols} from '@/assets/js/viscom/viscomjs/utils/SplitText';

export default {
    name: 'authors',

    props: {
        base: {
            type: String,
            default: ''
        },
        decoration: {
            type: Object,
            default: () => {
                return {};
            }
        },
        active: {
            default: false,
            type: Boolean
        }
    },

    components: {
        Decoration
    },

    data() {
        return {
            content: data.content.authors || {}
        };
    },

    computed: {
        title() {
            return this.content.title;
        },

        realTitle() {
            return this.titleHTML(this.title);
        },

        people() {
            return this.content.people;
        }
    },

    methods: {
        titleHTML(text) {
            if (!text) return '';

            // 1. Spanize
            const wrap = wrapHTMLSymbols(text, {
                cssProperty: 'transition',
                delay: 0,
                factor: 2,
                delayRatio: 0.4,
                delayMax: 0.08,
                delayMin: 0.03,
                durationRatio: 0.5,
                durationMax: 0.09,
                durationMin: 0.09,
                reverse: false,
                center: false,
                nestingNum: 1,
                applyTiming: true,
                flowType: 'container',
                timingNestingLevel: 0
            });

            return wrap.html;
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
//
.authors {
    box-sizing: border-box;
    padding: 0 var(--width-column-grid);
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        padding: 0;
        margin-bottom: 4rem;

        .decoration {
            display: none;
        }
    }

    &__wrap {
        display: flex;
        flex-direction: row;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            padding: 0 var(--scr-padding-side);
            display: block;
        }
    }

    .h3 {
        margin-bottom: 2em;

        .symbol-wrap-root {
            transition: opacity 0.05s;
        }

        &:not(.entered) {
            .symbol-wrap-root {
                opacity: 0;
            }
        }
    }

    &__title {
        font-size: 1.25em;
        text-transform: uppercase;
        width: 45%;
        display: flex;
        flex-direction: column;

        .decor {
            display: block;
        }

        .h3 {
            width: 81.63333%;
            margin-left: auto;
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 80%;
            display: block;

            .h3 {
                width: 100%;
                margin-left: 0;
            }
        }
    }

    &__text {
        width: 54%;
        padding-top: 2.2em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 100%;
            padding-top: 0;
        }
    }
}

.author-list {
    @media (--viewport-mobile), (--viewport-tablet-pt) {
        line-height: 1.85;
    }

    &__item {
        padding-left: 1.2em;
        margin-bottom: 2em;
        position: relative;
        transition: opacity 0.6s cubic-bezier(0.14, 0, 0.21, 1), transform 0.6s cubic-bezier(0.14, 0, 0.21, 1);
        will-change: opacity, transform;

        &:not(.entered) {
            opacity: 0;
            transform: translateY(0.5em) scale(1, 1.05);
        }

        &::before {
            content: '>';
            font-weight: bold;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    &__position,
    &__names {
        display: inline;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            display: block;
        }
    }

    &__position {
        @media (--viewport-mobile), (--viewport-tablet-pt) {
            font-weight: bold;
        }

        &::after {
            content: ' ';
            display: inline;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                content: none;
            }
        }
    }

    &__names {
        &::before {
            content: ' – ';
            display: inline;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                content: none;
            }
        }

        span {
            display: inline-block;

            &:after {
                content: ', ';
                display: inline;
            }

            &:last-child {
                &:after {
                    content: none;
                }
            }

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                display: block;
            }
        }
    }
}
</style>
